import { render, staticRenderFns } from "./VacancyReport.vue?vue&type=template&id=b98eda9a&"
import script from "./VacancyReport.vue?vue&type=script&lang=js&"
export * from "./VacancyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports